import { useEffect } from 'react'

// Classic's keyboard focus ring (#822) without template CSS: Classic has none
// (ARCHITECTURE §7.1 rules 1–2). The same rule classic.css carried, as
// utilities on <html> while a Classic nav is mounted: a 2px primary outline,
// offset 2px, on :focus-visible only. `:where()` keeps it at one class of
// specificity, so controls that style their own focus (focus:outline-none +
// ring) keep theirs.
const RING = [
  '[&_:where(:focus-visible)]:outline',
  '[&_:where(:focus-visible)]:outline-2',
  '[&_:where(:focus-visible)]:outline-offset-2',
  '[&_:where(:focus-visible)]:outline-primary',
]

let mounted = 0

export function useClassicFocusRing() {
  useEffect(() => {
    const root = document.documentElement
    if (mounted++ === 0) root.classList.add(...RING)
    return () => {
      if (--mounted === 0) root.classList.remove(...RING)
    }
  }, [])
}
